<template>
    <!-- 私教课程设置 -->
    <div class="private-lessons-components">
        <div class="container-content">
            <div class="content-store">
                <div class="content-title flex justify-between">
                    <div class="flex items-center">{{ $t('Member.Follow.personal_name') }}</div>
                    <div class="flex">
                        <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                            <div class="iconfont add icon-fitness-tianjiawenjian"
                                @click="handleAddLessons('add')">
                            </div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                            <div
                                class="iconfont
                                    edit
                                    icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                @click="handleAddLessons('edit')">
                            </div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('Lesson.pay_setting')" placement="bottom">
                            <div class="iconfont pay icon-fitness-qian" @click="handlePay"></div>
                        </el-tooltip>
                        <!-- 根据clickActive判断icon及方法 -->
                        <el-tooltip effect="dark" :content="clickActive ? '删除' : '恢复'" placement="bottom">
                            <div
                                :class="clickActive ? 'icon-fitness-shanchu' : 'icon-fitness-huifu1'"
                                class="iconfont delete"
                                @click="handleLessons">
                            </div>
                        </el-tooltip>
                    </div>
                </div>
                <div class="content-info">
                    <el-select
                        v-on:change="fetchData"
                        class="private-lessons-select"
                        v-model="form.storeId"
                        :placeholder="$t('Common.store_placeholder')">
                        <el-option
                            v-for="(item, index) in stores"
                            :key="`${index}-${item.id}`"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <ul v-for="(i, index) in data" :key="index">
                        <li
                            @click="changeList(i.id)"
                            :class="clickIndex == i.id ? 'clicked' : ''">
                            {{ i.name }}{{ i.singlePurchase ? '&nbsp; | &nbsp;储值卡单次可买' : '' }}
                            <span style="float: right;">{{ i.active ? '' : '（已删除）' }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="content-select">
                <div class="content-title flex justify-between">
                    <div class="flex items-center">{{ $t('Course.personal_price') }}</div>
                    <div class="flex">
                        <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                            <div class="iconfont add icon-fitness-tianjiawenjian" @click="handleEdit('add')"></div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                            <div
                                class="iconfont edit icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                @click="handleEdit('edit')"></div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                            <div class="iconfont delete icon-fitness-shanchu" @click="handleDelete"></div>
                        </el-tooltip>
                    </div>
                </div>
                <div class="content-info">
                    <el-table
                        ref="table"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%;margin-bottom: 15px;"
                        highlight-current-row
                        @current-change="handleCurrentChange"
                        border>
                        <el-table-column prop="storeName" :label="$t('Sell.sell_store')" />
                        <el-table-column prop="priceLevel" :label="$t('Course.CoursePriceLevel')" />
                        <el-table-column prop="countInterval" :label="$t('Lesson.count_to')" />
                        <el-table-column prop="normalPrice" :label="$t('Sell.Pay.money2')" />
                        <el-table-column prop="transferFee" :label="$t('Reception.Fifth.fee')" />
                        <el-table-column prop="publishAt" :label="$t('Course.release_time')" />
                        <el-table-column :label="$t('Reception.Fourth.status')">
                            <template slot-scope="{row, $index}">
                                <span
                                    :class="row.status === '可售'
                                    ? 'person-lesson-green'
                                    : 'person-lesson-red'"
                                >
                                    {{ row.status }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- <el-pagination
                        v-if="tableData && tableData.length"
                        class="text-right"
                        @current-change="fetchData"
                        :current-page.sync="form.page"
                        :page-size="pagination.size"
                        layout="total, prev, pager, next, jumper"
                        :total="pagination.total">
                    </el-pagination> -->
                </div>
            </div>
        </div>

        <!-- 添加/编辑私教课程 -->
        <add-lessons ref="lessons" @fetchData="fetchData" />
        <!-- 付费设置 -->
        <setting-pay ref="pay" @fetchData="fetchData" />
        <!-- 私教课程价格设定 -->
        <course-price ref="price" @fetchData="fetchData" />

    </div>
</template>

<script>
import AddLessons from '@/components/Dialog/PrivateLessons/AddLessons.vue';
import SettingPay from '@/components/Dialog/PrivateLessons/SettingPay.vue';
import CoursePrice from '@/components/Dialog/PrivateLessons/CoursePrice.vue';

export default {
    name: 'private-lessons',
    components: {
        AddLessons,
        SettingPay,
        CoursePrice,
    },
    props: ['activeName'],
    data() {
        return {
            // pagination: {
            //     size: 10,
            //     total: 0,
            // },
            form: {
                page: 1,
                storeId: null,
            },
            stores: [],
            data: [],
            clickIndex: null,
            clickActive: null,
            tableData: [],
            currentRow: null,
        };
    },
    watch: {
        'activeName'(val) {
            if (val === 'fourth') {
                this.fetchStore();
                this.fetchData();
            }
        },
    },
    created() {
        if (this.activeName === 'fourth') {
            this.fetchStore();
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            this.clickIndex = null;
            this.currentRow = null;
            this.data = [];
            this.tableData = [];
            API.get('lesson/coach/list', {
                params: this.form,
            }).then(res => {
                if (res && res.length) {
                    this.clickIndex = this.clickIndex ? this.clickIndex : res[0].id;
                    this.data = res;
                    // 获取私教价格列表
                    this.fetchList();
                    // 获取选中私教课程的状态
                    this.fetchItem();
                }
            });
        },
        fetchList() {
            API.get(`lesson/coach/${this.clickIndex}/price-list`, {
                params: {
                    storeId: this.form.storeId,
                },
            }).then(res => {
                this.tableData = res;
            }).catch(() => {
            }).finally(() => {});
        },
        // 添加私教课程
        handleAddLessons(type) {
            if (this.$$filterPermission('课程-课程设置-团课/私教课程添加 修改 删除')) {
                this.$refs.lessons.open(type, this.clickIndex);
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        // 私教课程价格设定
        handleEdit(type) {
            if (!this.$$filterPermission('课程-课程设置-私教课程价格 添加 编辑 删除')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return;
            }
            const name = this.data.find(el => el.id === this.clickIndex).name.split(' ')[0];
            const storeId = this.form.storeId;
            const lessonId = this.clickIndex;
            const priceId = this.currentRow ? this.currentRow.id : null;
            if (!this.data.length) $ele.$message(this.$t('Course.Selfless_teach_no'));
            else if (type === 'add') this.$refs.price.open(name, storeId, lessonId);
            else if (type === 'edit' && !this.currentRow) $ele.$message(this.$t('Course.choose_price'));
            else this.$refs.price.open(name, storeId, lessonId, priceId);
        },
        handlePay() {
            const singlePurchase = this.data.find(el => el.id === this.clickIndex).singlePurchase;
            if (!singlePurchase) $ele.$message(this.$t('Course.not_support_single'));
            else this.$refs.pay.open(this.clickIndex);
        },
        // 获取选中私教课程的状态
        fetchItem() {
            const active = this.data.find(el => el.id === this.clickIndex).active;
            this.clickActive = active;
        },
        handleLessons() {
            const tip = this.clickActive ? '确定删除该课程？' : this.$t('Message.tip_title');
            const msg = this.clickActive ? '删除课程后，会员将无法继续预约该课程~' : '确定恢复该课程？';
            $ele.$confirm(msg, tip, {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (!this.$$filterPermission('课程-课程设置-团课/私教课程添加 修改 删除')) {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                    return;
                }
                this.Back();
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        Back() {
            let request;
            if (this.clickActive) request = API.delete(`lesson/coach/${this.clickIndex}/active`);
            else request = API.put(`lesson/coach/${this.clickIndex}/active`);
            request.then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            }).catch(() => {}).finally(() => {});
        },
        handleDelete() {
            if (!this.currentRow) return $ele.$message(this.$t('Course.choose_price'));
            $ele.$confirm(this.$t('Course.delete_ok'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                // 删除接口 - 已经删除提示： 此设定已删除！！不要重复删除！
                if (!this.$$filterPermission('课程-课程设置-私教课程价格 添加 编辑 删除')) {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                    return;
                }
                if (this.currentRow.status === '可售') this.Delete();
                else $ele.$message(this.$t('Course.non_rep'));
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        Delete() {
            let request;
            if (this.currentRow.status === '可售') {
                request = API.delete(`lesson/coach/price/${this.currentRow.id}/active`);
            }
            // else request = API.put(`lesson/coach/price/${this.currentRow.id}/active`);
            request.then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            }).catch(() => {}).finally(() => {});
        },
        changeList(id) {
            this.clickIndex = id;
            // 接口获取数据
            this.fetchList();
            // 获取门店状态删除已否
            this.fetchItem();
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = [];
                this.stores.push({
                    id: null,
                    name: this.$t('Common.all_store2'),
                });
                res.map(el => {
                    this.stores.push(el);
                    return this.stores;
                });
            });
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
    },
};
</script>

<style lang="scss">
.private-lessons-components {
    .el-table__row {
        cursor: pointer;
    }
    .search {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 15px;
    }
    .search-input {
        width: 400px;
    }
    .container-content {
        font-size: 14px;
        color: #666;
        margin-top: 15px;
    }
    .content-store,
    .content-select {
        width: 25%;
        margin-right: 1%;
        border: 1px solid #e6e6e6;
        display: inline-block;
        vertical-align: text-top;
        display: inline-block;
        vertical-align: top;
    }
    .content-select {
        width: 74%;
        margin-right: 0;
    }
    .content-title {
        font-size: 13px;
        background: #fafafa;
        padding: 18px 20px;
        border-bottom: 1px solid #e6e6e6;
    }
    .add,
    .delete,
    .edit,
    .pay {
        color: #697a8e;
    }
    .add {
        font-size: 18px;
    }
    .edit {
        margin: 0 12px;
    }
    .pay {
        margin-right: 12px;
    }
    .content-info {
        color: rgb(102, 102, 102);
        padding: 15px;
        font-size: 13px;
    }
    ul {
        padding-left: 0;
    }
    li {
        list-style: none;
        list-style-position: inside;
        margin: 15px 0;
        cursor: pointer;
    }
    .clicked {
        color: #05abef;
    }
}
.private-lessons-select {
    width: 100%;
}
.person-lesson-green {
    color: #2a9546;
}
.person-lesson-red {
    color: #db093f;
}
</style>
